module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAKZJREFUKFOFzqFKw3EUBeDvgDgGPoBPYPEFln2BIZitdoN5VXBh1bJFg1VweWHVahYxGYQhuvIbN/xBRLfb7jkflxtorZ3jBn0sMEkyr66btNaO8YS9nwUecJHktfKCY1z+Qt36jtMki4JLDP6BFa9wUvANh1tgVcuC39jfAT8KfqG3A84KPuNoC3zEWcFrXP0BXzDCNEkreIBbDPFZj+MO90nW3YENhDI5kZS52dcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/image1/shape1.png
// module id = 2OKh
// module chunks = 28